




import Vue from 'vue';
import { LakDruh } from '@/modules/ciselnik/dilenske/lakDruh';
import { types } from '@/modules/servis/zakazka/store/types';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'MicroLakDruhSelect',
	components: {
		LakDruhSelect: LakDruh.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_LAK_DRUH_SELECT_MAPPER}`,
			};
		},
		lakdruhFilter(): object {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				VyrazenPrp: false,
			};
		},
	},
});
